const LoadableMapComponents = () => <p>render only on server</p>;
export default LoadableMapComponents;
